var map = {
	"./pages/admin_basic_info/merchant_type/index.tsx": [
		262,
		0,
		1,
		2,
		7
	],
	"./pages/admin_basic_info/price_setting/index.tsx": [
		263,
		0,
		8
	],
	"./pages/client_orders/index.tsx": [
		264,
		0,
		1,
		2,
		9
	],
	"./pages/files/index.tsx": [
		265,
		0,
		1,
		2,
		10
	],
	"./pages/goods/index.tsx": [
		266,
		0,
		1,
		2,
		11
	],
	"./pages/manager_client/index.tsx": [
		267,
		0,
		1,
		2,
		12
	],
	"./pages/no_found/index.tsx": [
		121
	],
	"./pages/setting/index.tsx": [
		268,
		0,
		1,
		2,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 187;
module.exports = webpackAsyncContext;